// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../next/Next.bs.js");
var React = require("react");

function Redirect(props) {
  var path = props.path;
  var router = Next.useRouter();
  React.useEffect(function () {
        Next.Router.replace(path, undefined, undefined, router);
      });
  return null;
}

var make = Redirect;

exports.make = make;
/* Next Not a pure module */
